import React, { FunctionComponent } from "react";
import { useTranslation } from "react-i18next";

const Forbidden: FunctionComponent = () => {
  const { t } = useTranslation();
  return <div>{t("Shared.ForbiddenContent")}</div>;
};

export default Forbidden;
